export default __webpack_public_path__ + "static/43aa-696e2858e18a2a97fe6c75a1a0eb3f03.png";